import { render, staticRenderFns } from "./page-langues.vue?vue&type=template&id=3401679e&"
import script from "./page-langues.vue?vue&type=script&lang=js&"
export * from "./page-langues.vue?vue&type=script&lang=js&"
import style0 from "./page-langues.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports